import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import { ResendInviteEmailDocument, ResendInviteEmailMutation, ResendInviteEmailMutationVariables } from "@/graphql/__generated__/graphql";

export default function useResendInviteEmailMutationHook(): { resendInviteEmailMutation: any, loading: any, error: any } {
  const { t } = useTranslation(["toasts"]);

  const [resendInviteEmailMutation, { loading, error }] = useMutation<ResendInviteEmailMutation, ResendInviteEmailMutationVariables>(
    ResendInviteEmailDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "resend-invite-email-success",
          data: {
            title: t("toasts.sendinviteemail"),
            type: "success",
          }
        });
      }
    });

  return {
    resendInviteEmailMutation,
    loading,
    error
  };
}
